/**
 * Parses Quill Delta format comment JSON to plain text.
 * @param {string | undefined | null} comment
 * @returns {string}
 */
export function parseDeltaComment(comment) {
  if (!comment) {
    return '';
  }
  try {
    const delta = JSON.parse(comment);
    if (Array.isArray(delta)) {
      return delta
        .map((op) => (typeof op.insert === 'string' ? op.insert : ''))
        .join('');
    }
    return '';
  } catch {
    return comment;
  }
}
